interface RoleBearing {
  role: string | null | undefined;
}

const OAUTH_CLIENT_MANAGEMENT_ROLES = new Set(['system admin', 'manager']);
const CASE_ASSIGNMENT_ROLES = new Set(['system admin', 'manager', 'case officer', 'field officer']);

export function normalizeRoleName(role: string | null | undefined): string {
  return role?.trim().replace(/\s+/g, ' ').toLowerCase() ?? '';
}

export function canManageOAuthClients(user: RoleBearing | null | undefined): boolean {
  return OAUTH_CLIENT_MANAGEMENT_ROLES.has(normalizeRoleName(user?.role));
}

export function canAssignCases(user: RoleBearing | null | undefined): boolean {
  return CASE_ASSIGNMENT_ROLES.has(normalizeRoleName(user?.role));
}
